<div class="flex items-center justify-between pb-6">
  <div class="flex items-center gap-2" (click)="onProfileClick.emit();">
    <!--<vw-icon-svg
      iconUrl="{{
          user.profileImage == undefined
            ? '/assets/svg/user.svg'
            : user.profileImage
        }}"
      additionalClasses=""
      width="48"
      height="48"
    ></vw-icon-svg>-->
    <div (click)="handlerClickOnUserGreeting($event)">
      @if (user && user.pseudo) {
        <p class="text-[#7A8581] text-sm" [innerHTML]="'home.header.greeting' | translate: {firstName: user.pseudo}"></p>
      }
      @if (!user || !user.pseudo) {
        <p class="text-[#7A8581] text-sm" [innerHTML]="'home.header.greeting-guest' | translate"></p>
      }
    </div>
  </div>
  <div class="flex items-center gap-2">
    <div class="relative bg-primary-500 rounded-full p-2 active:bg-primary-800 cursor-pointer" (click)="handleBell($event)">
      <vw-bell-icon
        class="w-5 h-5 text-white stroke-1">
      </vw-bell-icon>
      @if (unreadCount > 0) {
        <span class="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[16px] h-4 flex items-center justify-center px-0.5">
          {{ unreadCount > 9 ? '9+' : unreadCount }}
        </span>
      }
    </div>
    <vw-book-icon (click)="handleGuide($event)"
      class="bg-primary-500 text-white text-sm stroke-1 rounded-full p-2 active:bg-primary-800">
    </vw-book-icon>
  </div>
</div>
